import { Component } from '@angular/core';
import { NavController, AlertController, Platform, ActionSheetController } from 'ionic-angular';
import { MenusService } from '../../providers/menus-service';
import { PreferencesService} from '../../providers/preferences-service';
import { Storage } from '@ionic/storage';
import { AuthentificationService} from '../../providers/authentification-service';
import { AngularFire } from 'angularfire2';
import "rxjs/add/operator/filter";

@Component({
  selector: 'page-menus',
  templateUrl: 'menus.html'
})
/*
  Generated class for the Menus page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
	La page Menus s'occupe d'afficher les menus du jour/semaine pour le restaurant choisi
*/
export class ListMenus {
	
 		public restaurants: any;//variable de base pour le JSON contenant les menus

		public curImage: any;//variable contenant le résultat pour une image

		public selectedRestaurantIdx:number;//valeur par defaut du selector 
		//Constructeur de la page menus.ts
	  constructor(public platform: Platform, 
	  public actionSheetCtrl: ActionSheetController,
	  public navCtrl: NavController,
	  public alertCtrl: AlertController,
		public menusService: MenusService,
		public storage: Storage,
		public authentificationService: AuthentificationService,
		public af: AngularFire,
		public preferencesService: PreferencesService) {
		  this.loadMenus();
			this.selectedRestaurantIdx=0;
	  }
		//Methode qui change le menu affiché selon le tab choisi en haut de la page
		changeMenus(index:number)
		{
			this.selectedRestaurantIdx=index;
		}
		//Ouvre le popup pour ajouter un plat aux préférés
		openMenu(ingredient: string) {
			let actionSheet = this.actionSheetCtrl.create({
			  title: 'Ajouter '+ingredient+' à vos plats préférés?',
			  cssClass: 'action-sheets-basic-page',
			  buttons: [
				{
				  text: 'Ajouter',
				  icon: !this.platform.is('ios') ? 'heart-outline' : null,
				  handler: () => 
				  {
						this.addDishToFavs(ingredient);
				  }
				},
				{
				  text: 'Annuler',
				  role: 'cancel', // will always sort to be on the bottom
				  icon: !this.platform.is('ios') ? 'close' : null,
				  handler: () => 
				  {
					console.log('Cancel clicked');
				  }
				}
			  ]
			});
			actionSheet.present();
		}
		//Ajoute un plat aux plats favoris de l'utilisateur courant
		addDishToFavs(ingredient: string) {
			this.menusService.addFavoriteMenu(ingredient);
	  }
		/*
		* Loads the menus into the variable restaurants
		*/
		loadMenus(){
			this.storage.get('restaurants_date').then((val) => {//Check time stamp of the menu stored locally
				if(val !== null){//There is a time stamp stored locally
					//Proccess the stored time stamp and current time, in order to compare the two
					var storedDate : Date = new Date(val);
					var storedWeekN = this.weekNumber(storedDate);
					var storedYear = this.year(storedDate);
					var currentDate = new Date();
					var currentWeekN = this.weekNumber(currentDate);
					var currentYear = this.year(currentDate);
					if(storedWeekN == currentWeekN && storedYear == currentYear )//The menu stored locally if up to date
					{
						this.storage.get('restaurants').then((val) => {//Load the menu stored locally
								this.restaurants = val;
							});
							return;//exit method
					} 
				}
				//The menu stored locally is outdated
				this.menusService.loadMenus().then(data => {//Request the menus from menus-service
					//Load them
					this.restaurants = data['restaurants'];
					//Store them locally
					this.storage.set('restaurants_date', new Date());
					this.storage.set('restaurants', this.restaurants);
					console.log('New menus saved in storage');
				});
			});
		}

	/*
	* Requests the menus from menus-service, and saves them locally.
	* It overwrites any menus present locally
	*/
	forceReloadMenus(){
			this.menusService.loadMenus().then(data => {
				this.restaurants = data['restaurants'];
				this.storage.set('restaurants_date', new Date());
				this.storage.set('restaurants', this.restaurants);
				console.log('New menus saved in storage');
			});
		}
		
	/*
	* doRefresh event handler
	* Called from the refresher
	* Calls forceReloadMenus 
	*/
	doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    setTimeout(() => {
				this.forceReloadMenus();
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

	/*
	* Returns the week number of a given date 
	* Source: https://weeknumber.net/how-to/javascript
	*/
	weekNumber(date) : any {
		date.setHours(0, 0, 0, 0);
		// Thursday in current week decides the year.
		date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
		// January 4 is always in week 1.
		var week1 = new Date(date.getFullYear(), 0, 4);
		// Adjust to Thursday in week 1 and count number of weeks from date to week1.
		var weekN = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
													- 3 + (week1.getDay() + 6) % 7) / 7);
		return weekN;
	}
	/*
	* Returns the year of a given date
	* Format : yyyy
	*/
	year(date) : any {
  	date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  	return date.getFullYear();
	}
	  
}



// WEBPACK FOOTER //
// ./src/pages/menus/menus.ts